import {parse} from 'query-string';
import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {collectionApi} from '@px/api/collection';
import {url$} from './url';

const REFERRAL_KEY = 'referral-v1';

export const referral$ = new BehaviorSubject<Referral>(readLocalReferral());

url$.pipe(filter((url: Url) => url && !!url.query.referralCode)).subscribe((url) => {
  const {referralCode, group} = url.query;
  referral$.next({code: referralCode, group: Number(group)});
});

referral$.subscribe(({code, group}) => {
  if (!code || code === 'null') {
    return;
  }

  localStorage.setItem(REFERRAL_KEY, [code || '', String(group) || '0'].join(','));
});

export function updateReferral() {
  const {referralCode, group} = parse(window.location.search);
  referralCode && localStorage.setItem(REFERRAL_KEY, [referralCode || '', group || '0'].join(','));
  if (group) {
    collectionApi.cnt(group);
  }
}

function readLocalReferral(): Referral {
  const referral = localStorage.getItem(REFERRAL_KEY);
  if (referral) {
    const [code, group] = referral.split(',');
    return {code: code === 'null' ? '' : code, group: Number(group)};
  }

  return {code: '', group: 0};
}
